export const Role = {
    Admin: 'cd4d4778-a34c-4a21-8ed6-039218ecc63c',
    User: '70ce9309-abb1-4afb-9e02-b2288fb86ba2',
    Observer: '8549c313-b7b0-41e7-a1cd-f88bb9daf011'
}